export const InvoiceValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.formData.CustomerID || formData.formData.CustomerID==="0") {
        errors.CustomerID = 'This field is required';
    }

    if (!formData.formData.FK_ClientBranch_ID || formData.formData.FK_ClientBranch_ID==="0") {
        errors.FK_ClientBranch_ID = 'This field is required';
    }
    if (!formData.formData.FK_ClientContact_ID || formData.formData.FK_ClientContact_ID==="0") {
        errors.FK_ClientContact_ID = 'This field is required';
    }   
    if (!formData.formData.dt_InvoiceDate.trim()) {
        errors.dt_InvoiceDate = 'This field is required';
    }
    if (!formData.formData.FK_InvoiceType_ID || formData.formData.FK_InvoiceType_ID=="0") {
        errors.FK_InvoiceType_ID = 'This field is required';
    }
    return errors;
};
